module.exports = __webpack_public_path__ + "img/home-ipad-bg_en.2f071f9.jpg";